import { Component, inject, input } from '@angular/core';

import { BaseDeleteButtonComponent } from '../../../../../shared/base-classes/base-delete-button.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { DialogsService } from '../../../../../shared/services/dialogs.service';
import { VehicleRoadWorthyChecksService } from '../../vehicle-road-worthy-checks.service';

@Component({
	selector: 'app-vehicle-road-worthy-check-delete-button',
	templateUrl: 'vehicle-road-worthy-check-delete-button.component.html',
	imports: [UltraMenuItemWrapperComponent, UltraMenuItemComponent],
})
export class VehicleRoadWorthyCheckDeleteButtonComponent extends BaseDeleteButtonComponent {
	private _vehicleRoadWorthyChecksService = inject(
		VehicleRoadWorthyChecksService,
	);
	private _dialogsService = inject(DialogsService);

	code = input<string>();

	onDelete() {
		this._dialogsService.openDeleteRecordDialog(
			{
				confirmed: () => {
					this._vehicleRoadWorthyChecksService
						.deleteRecord(this.id())
						.subscribe((res) => {
							this.onDeleteCalled.emit(res);
						});
				},
			},
			this.code(),
		);
	}
}
